module.exports = __webpack_public_path__ + "img/svg/phone-in-talk-d0cbc455.svg";